import { defineStore } from 'pinia'

interface State {
  locales: string[]
  locale: string
  notification_dropdown: boolean
  user_dropdown: boolean
  menu: boolean
  callBack: boolean
}

export const useMainStore = defineStore('main', {
  state: (): State => ({
    locales: ['en', 'ru'],
    locale: 'ru',
    notification_dropdown: false,
    user_dropdown: false,
    menu: false,
    callBack: false
  }),

  getters: {
    get_notifications_dropdown: (state) => state.notification_dropdown,
    get_user_dropdown: (state) => state.user_dropdown
  },

  actions: {
    SET_LANG(locale: string) {
      if (this.locales.includes(locale)) {
        this.locale = locale
      }
    },
    set_notifications_dropdown() {
      this.notification_dropdown = !this.notification_dropdown
    },
    set_user_dropdown() {
      this.user_dropdown = !this.user_dropdown
    },
    setMenu(menu: boolean) {
      console.log(menu)
      this.menu = menu
    },
    setCallBack(callBack: boolean) {
      console.log(callBack)
      this.callBack = callBack
    }
  }
})
